import { Component, computed, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LottieAnimationComponent } from 'src/app/@shared/components/lottie-animation/lottie-animation.component';
import { SanitizeHtmlPipe } from 'src/app/@shared/pipes/sanitizeHtml.pipe';
import { CreditsOverviewComponent } from 'src/app/features/credits/components/credits-overview/credits-overview.component';
import { UserCreditsData, UserCreditsService } from 'src/app/features/credits/services/user-credits.service';
import { ButtonComponent } from 'src/app/@core/components/ui/button/button.component';

@Component({
  selector: 'app-generation-loader',
  standalone: true,
  imports: [CommonModule, LottieAnimationComponent, SanitizeHtmlPipe, CreditsOverviewComponent, ButtonComponent],
  templateUrl: './generation-loader.component.html',
})
export class GenerationLoaderComponent {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() animationData: unknown = null;
  @Input() bottomImageSvg: string = '';
  @Input() feature: string = '';
  @Input() featureId: string = '';
  @Input() actionLabel: string = '';
  @Input() animationWidth: string = '300px';
  @Input() animationHeight: string = '300px';

  @Output() resume = new EventEmitter<{ threadId?: string }>();
  @Output() action = new EventEmitter<void>();

  fetchedCredits = signal<UserCreditsData | null>(null);

  loading = true

  hasExhaustion = []

  constructor(private userCreditsService: UserCreditsService) { }

  ngOnInit(): void {
    if (this.feature && this.featureId) {
      this.fetchCredits();
    }
  }

  onResume(event: { threadId?: string }): void {
    this.fetchCredits();
    this.resume.emit(event);
  }

  private fetchCredits(): void {
    this.loading = true;
    this.userCreditsService.getCurrentCredits().subscribe({
      next: (res: any) => {
        this.fetchedCredits.set(res?.data || res)
        this.hasExhaustion = res?.data?.exhaustions?.filter((exhaustion: any) => exhaustion.feature === this.feature && exhaustion.featureId === this.featureId) || [];
        this.loading = false;
      }
    });
  }
}
